import React, { useCallback, useEffect } from 'react'
import Dashhwm from './dashhwm'
import { useNavigate } from 'react-router';
import RevampBanner from '../components/RevampBanner'

const WealthManagerDashboard = () => {
  const navigate = useNavigate()
    const finvolveWealthManagerData = JSON.parse(localStorage.getItem("finvolveWealthManagerData"));

    const checkIfUserIsLoggedIn = useCallback(async()=>{
        const finvolveWealthManagerData = JSON.parse(localStorage.getItem("finvolveWealthManagerData"))
        if(!finvolveWealthManagerData?.email){
            navigate("/wealth-manager-login")
            return
        }
    },[navigate])

    useEffect(()=>{
      checkIfUserIsLoggedIn();
    },[checkIfUserIsLoggedIn])

    if(!finvolveWealthManagerData?.email){
        return
    }
    
  return (
    <div>
        <RevampBanner part="description" sx={{ borderRadius: 0 }}/>
        <Dashhwm/>
    </div>
  )
}

export default WealthManagerDashboard